import { Component, DoCheck, Input, OnInit, TemplateRef } from '@angular/core';
import { BulkActionEntry } from '@app/shared/models/bulk-action-entry';
import { BulkActionEntryState } from '@app/shared/models/bulk-action-entry-state';
import { UserWithExtension } from '@app/shared/models/user-with-extension';
import { StringMap } from '@app/utils/string-map';

@Component({
  selector: 'portal-default-bulk-action-entry',
  templateUrl: './default-bulk-action-entry.component.html',
  styles: [],
  host: {
    class: 'bulk-action__default-entry',
  },
  standalone: false,
})
export class DefaultBulkActionEntryComponent implements DoCheck, OnInit {
  @Input()
  public bodyTemplate: TemplateRef<any>;

  @Input()
  public bulkActionEntry: BulkActionEntry<UserWithExtension>;

  @Input()
  public collapsed: boolean = true;

  @Input()
  public disabled: boolean = false;

  @Input()
  public errorTemplate: TemplateRef<any>;

  @Input()
  public headerTemplate: TemplateRef<any>;

  public context: StringMap<any>;
  public entry: UserWithExtension;

  public state?: 'danger' | 'info' | 'secondary' | 'success' | 'warning' | 'primary';
  public stateIcon?: string;
  public stateTooltip?: string;

  ngDoCheck(): void {
    if (this.bulkActionEntry.failure !== undefined) {
      this.state = 'danger';
      this.stateIcon = 'far fa-bolt';
      this.stateTooltip = 'bulk.action.entry.processingFailed';
    } else if (this.bulkActionEntry.state !== BulkActionEntryState.UNCHANGED) {
      if (this.bulkActionEntry.active) {
        this.state = undefined;
      } else {
        this.state = 'primary';
      }

      if (this.bulkActionEntry.processing === true) {
        this.stateIcon = 'far fa-circle-notch fa-spin';
        this.stateTooltip = 'bulk.action.entry.processingIsActive';
      } else if (this.bulkActionEntry.state === BulkActionEntryState.ADDED) {
        this.stateIcon = 'far fa-plus-circle';
        this.stateTooltip = 'bulk.action.entry.to.add';
      } else {
        this.stateIcon = 'far fa-minus-circle';
        this.stateTooltip = 'bulk.action.entry.to.remove';
      }
    } else if (this.bulkActionEntry.success) {
      if (this.bulkActionEntry.active) {
        this.state = undefined;
      } else {
        this.state = 'primary';
      }

      this.stateIcon = 'far fa-check';
      this.stateTooltip = 'bulk.action.entry.processingWasSuccessful';
    } else {
      this.stateIcon = undefined;
      this.stateTooltip = undefined;

      if (this.bulkActionEntry.active) {
        this.state = 'primary';
      } else {
        this.state = undefined;
      }
    }
  }

  ngOnInit() {
    this.entry = this.bulkActionEntry.entry;

    this.context = {
      $implicit: this.entry,
    };
  }

  public toggleCollapse($event: MouseEvent) {
    $event.stopPropagation();

    this.collapsed = !this.collapsed;
  }
}
